export default {
  routerCenter: { enabled: true },
  consumptionRecord: { enabled: true },
  modifyCouponPage: { enabled: true },
  personalCenter: { enabled: true },
  personalDetail: { enabled: true },
  myCoupon: { enabled: true },
  createMakeAnAppointment: { enabled: true },
  writeOffOperation: { enabled: true },
  myRecordTable: { enabled: true },
  couponInfoDetail: { enabled: true },
  cancelRecord: { enabled: true },
  certificationAuditView: { enabled: true },
  certificationDetail: { enabled: true },
  cardOperationSearch: { enabled: true },
  myInsuranceRecord: { enabled: true },
  myStoredValueRecord: { enabled: true },
  grantOfCoupon: { enabled: true },
  pointsMailHomePage: { enabled: true },
  productDetails: { enabled: true },
  productSearch: { enabled: true },
  exchangeRecord: { enabled: true },
  myPoints: { enabled: true },
  rankEquity: { enabled: true },
  rankEquityDetails: { enabled: true },
  productOrder: { enabled: true },
  paymentDetails: { enabled: true },
  shopptingCart: { enabled: true },
  pointsMailCashier: { enabled: true },
  recordsOfConsumption: { enabled: true },
  myOrder: { enabled: true },
  myOrderDetails: { enabled: true },
  myExtendedInsurance: { enabled: true },
  myExtendedInsuranceDetails: { enabled: true },
  personalInformation: { enabled: true },
  myStoredValue: { enabled: true },
  commonProblem: { enabled: true },
  exclusiveCustomerService: { enabled: true },
  share: { enabled: true },
  myStoredValueDetails: { enabled: true },
  myStoredValueCode: { enabled: true },
  myExtendedInsuranceBriefIntroduction: { enabled: true },
  myCar: { enabled: true },
  addMyCar: { enabled: true },
  pointsMailHomePageNew: { enabled: true },
  testDrive: { enabled: true },
  veentDetails: { enabled: true },
  discountDetails: { enabled: true },
  practicalSkillsDetails: { enabled: true },
  makeAnAppointment: { enabled: true },
  pageMailService: { enabled: true },
  oneClickRenewal: { enabled: true },
  annualInspectionAgency: { enabled: true },
  oilCardRecharge: { enabled: true },
  financialService: { enabled: true },
  carWashService: { enabled: true },
  myCarServe: { enabled: true },
  extendedInsurance: { enabled: true },
  coupon: { enabled: true },
  storedValueWallet: { enabled: true },
  mySetUp: { enabled: true },
  productPay: { enabled: true },
  commodityClass: { enabled: true },
  commodityList: { enabled: true },
  oneClickRescue: { enabled: true },
  consumptionInfo: { enabled: true },
  storedValueWalletInfo: { enabled: true },
  newDetection: { enabled: true },
  preInspectionRecord: { enabled: true },
  completionRecord: { enabled: true },
  completionModification: { enabled: true }
}



// WEBPACK FOOTER //
// ./src/router/router-config-prod.js